import { BaseCoreGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/BaseCoreGameCommunicationProcessor';
import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';
import { gameStateActions } from '@pp/core/src/store/slices/game/slice';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import type { GameStore } from '../../../store/GameStore';
import { crashAutoplayActions } from '../../../store/slices/crashAutoplay/slice';
import { airPlaneActions } from '../../../store/slices/highflyerAirPlane/slice';
import { airplaneStates } from '../../../store/slices/highflyerAirPlane/types';
import { highflyerGameStateActions } from '../../../store/slices/highflyerGame/slice';
import { recentResultDetailStateActions } from '../../../store/slices/recentResultDetail/slice';

export interface GameResultMessage extends GameCommunicationMessageType {
  encryptedResult: string;
  gId: string;
  gameType: string;
  gr: number;
  hashKey: string;
  resultTime: string;
  jackpot: string;
}

export class GameHFCommunicationGameResultProcessor extends BaseCoreGameCommunicationProcessor {
  messageName = 'gr';
  delay = 0;

  process(message: GameResultMessage, store: GameStore): void {
    const processDelay: number = 100;
    const { crashAutoplay, bets, highflyerState } = store.getState();
    Object.keys(bets?.betList || {})
      .map(Number)
      .forEach((bet) => {
        const betId = bets.betList ? bets.betList[bet] : 1;

        const crashAutoPlayInProgress = crashAutoplay.isInProgress[betId];
        const crashAutoIsthisRoundOnly = crashAutoplay.isThisRoundOnly[betId];
        const hasEarlyBets = highflyerState.earlyBetAmount[betId] > 0;
        if (crashAutoPlayInProgress && crashAutoIsthisRoundOnly && !hasEarlyBets) {
          store.dispatch(crashAutoplayActions.setIsThisRoundOnly({ bestSpot: Number(betId), thisRoundonly: false }));
        }
      });

    setTimeout(() => {
      store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.Result));
      this.handleGameResult(message, store);
    }, processDelay);
  }

  private handleGameResult(message: GameResultMessage, store: GameStore): void {
    store.dispatch(highflyerGameStateActions.showTimerInPLayBtnStatus(false));
    store.dispatch(airPlaneActions.setCurrentState(airplaneStates.FLEW_AWAY));
    this.store.dispatch(gameStateActions.setWaitForWinResult(false));
    setTimeout(() => {
      store.dispatch(airPlaneActions.resetIsAnimating());
    }, 800);
    const data = {
      gameEncryptedResult: message.encryptedResult,
      gameHashKey: message.hashKey,
      gameId: message.gId,
      gameResult: message.gr,
      gameType: message.gameType,
      resultTime: message.resultTime,
    };
    store.dispatch(highflyerGameStateActions.setJackpot(message.jackpot === 'true'));
    store.dispatch(
      highflyerGameStateActions.prependRecentResult({
        gameEncryptedResult: data.gameEncryptedResult,
        gameHashKey: data.gameHashKey,
        gameId: data.gameId,
        gameResult: data.gameResult,
        gameType: data.gameType,
        resultTime: data.resultTime,
      })
    );

    const prevInd = store.getState().recentResultDetailState.hashModalData.index;
    if (prevInd >= -1) {
      if (store.getState().recentResultDetailState.hashModalData.clickedTab !== 'footer') return;
      store.dispatch(recentResultDetailStateActions.setHashModalData({ index: prevInd + 1, clickedTab: 'footer' }));
    }
  }
}
